export default {
    id: "ba36a97c-7891-46fb-8f89-b88ad322659b",
    icon: "mdi-book",
    name: "libraryContent",
    title: "Library Content",
    description: "A block with content from library"
}